import { useEffect, useMemo, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { search } from '../content/search';

export default function Search() {
  const [params, setParams] = useSearchParams();
  const q = params.get('q') ?? '';
  const [term, setTerm] = useState(q);

  // Keep the input in step if the URL query changes (e.g. from the nav box).
  useEffect(() => {
    setTerm(q);
  }, [q]);

  const results = useMemo(() => (q.trim().length >= 2 ? search(q, 100) : []), [q]);

  return (
    <div className="page section-page">
      <div className="section-heading">
        <h2>Search</h2>
      </div>

      <form
        className="search-page-form"
        role="search"
        onSubmit={(e) => {
          e.preventDefault();
          const t = term.trim();
          setParams(t ? { q: t } : {});
        }}
      >
        <input
          type="search"
          className="search-page-input"
          placeholder="Search documentation…"
          aria-label="Search documentation"
          value={term}
          onChange={(e) => setTerm(e.target.value)}
          autoFocus
        />
        <button type="submit" className="search-page-btn">
          Search
        </button>
      </form>

      {q.trim().length < 2 ? (
        <p className="note">Type at least two characters to search the documentation.</p>
      ) : results.length === 0 ? (
        <div className="section-placeholder">
          <p>
            No documentation matches <strong>{q}</strong>.
          </p>
          <p className="note">Try fewer or different words.</p>
        </div>
      ) : (
        <>
          <p className="search-page-count">
            {results.length} result{results.length !== 1 ? 's' : ''} for <strong>{q}</strong>
          </p>
          <ul className="search-results">
            {results.map((hit) => (
              <li key={hit.slug} className="search-result">
                <Link to={`/docs/${hit.slug}`} className="search-result-title">
                  {hit.title}
                </Link>
                <div className="search-result-meta">
                  <span className="search-result-badge">{hit.platformLabel}</span>
                  {hit.groupLabel && <span className="search-result-group">{hit.groupLabel}</span>}
                </div>
                {hit.snippet.length > 0 && (
                  <p className="search-result-snippet">
                    {hit.snippet.map((seg, i) =>
                      seg.hit ? <mark key={i}>{seg.text}</mark> : <span key={i}>{seg.text}</span>,
                    )}
                  </p>
                )}
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
}
